import { render, staticRenderFns } from "./plan-save.vue?vue&type=template&id=6915fca9&scoped=true"
import script from "./plan-save.vue?vue&type=script&lang=ts"
export * from "./plan-save.vue?vue&type=script&lang=ts"
import style0 from "./plan-save.vue?vue&type=style&index=0&id=6915fca9&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6915fca9",
  null
  
)

export default component.exports